module.exports = __webpack_public_path__ + "img/error.5da0c649.png";